import React from 'react';
import PropTypes from 'prop-types';
import { PANEL_WIDTH_CSS_VAR } from 'src/js/modules/view/constants/common';

function ViewOverlay({ children, width = '100%', height = '100%' }) {
  const styles = {
    // The overlay is `position: fixed` with an explicit width, which makes `right`
    // over-constrained and ignored — so the panel docked at the right edge has to
    // be subtracted here for the topbar and tool layers to narrow with the view.
    width: `calc(${width} - var(${PANEL_WIDTH_CSS_VAR}, 0px))`,
    height,
  };

  return (
    <div className="ws-view-overlay" style={styles}>
      {children}
    </div>
  );
}

ViewOverlay.propTypes = {
  children: PropTypes.node.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default ViewOverlay;
